









































import { PointRate } from "@/graphql/client";
import { Component, Emit, Vue } from "vue-property-decorator";
import pointRateService from "@/service/pointRateService";
import ProgressLinear from "@/components/molecules/ProgressLinear.vue";

@Component({
  components: {
    ProgressLinear,
  },
})
export default class PointRateDeleteDialog extends Vue {
  //---------------------------
  // data
  //---------------------------
  isOpen = false;
  isProgressing = false;
  item: PointRate = pointRateService.defaultPointRate;
  //---------------------------
  // mounted
  //---------------------------
  //---------------------------
  // computed
  //---------------------------
  //---------------------------
  // methods
  //---------------------------
  /**
   * ダイアログを表示します.
   */
  public open(item: PointRate): void {
    this.item = item;

    this.isProgressing = false;
    this.isOpen = true;
  }

  /**
   * ダイアログを閉じます.
   */
  public close(): void {
    this.isProgressing = false;
    this.isOpen = false;
  }

  /**
   * 入力内容を保存します.
   */
  private deleteItem(): void {
    this.isProgressing = true;
    //delete
    pointRateService
      .deletePointRate(this.item)
      .then((result) => {
        this.isProgressing = false;
        this.notifySuccess(result as PointRate);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  /**
   * 処理成功
   */
  @Emit("onSuccess")
  public notifySuccess(deleted: PointRate): PointRate {
    return deleted;
  }
}
